import { FormControl, FormGroup } from '@angular/forms';
import { ApplianceDetailsSteppedFormField } from '../../models/appliance-details-stepped/appliance-details-stepped-form-field.enum';
import { ApplianceDetailsSteppedForm } from '../../models/appliance-details-stepped/appliance-details-stepped-form.interface';
import { CLPApplianceDetailsPersonDetailsForm } from '../../models/clp/clp-appliance-details-person-details-form.interface';
import { mockCLPApplianceDetailsPersonDetailForm } from '../clp/clp-appliance-details-person-details-form.mock';
import { mockModelAndSerialNumberFieldset } from './model-and-serial-number-fieldset.mock';

export const mockApplianceDetailsSteppedForm: ApplianceDetailsSteppedForm = {
  [ApplianceDetailsSteppedFormField.ApplianceCategoryCode]: new FormControl(
    null
  ),
  [ApplianceDetailsSteppedFormField.ApplianceCode]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.ApplianceCodeBuiltIn]: new FormControl(
    null
  ),
  [ApplianceDetailsSteppedFormField.BrandCode]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.Person]:
    new FormGroup<CLPApplianceDetailsPersonDetailsForm>(
      mockCLPApplianceDetailsPersonDetailForm
    ),
  [ApplianceDetailsSteppedFormField.ModelAndSerialNumber]: new FormGroup(
    mockModelAndSerialNumberFieldset
  ),
  [ApplianceDetailsSteppedFormField.PartsWarranty]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.PurchaseDate]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.PurchasePrice]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.Retailer]: new FormControl(null),
  [ApplianceDetailsSteppedFormField.Warranty]: new FormControl(null),
};
